<template>
  <div class id="Configure">
    <!-- <mt-header fixed title="车辆配置">
      <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
    </mt-header> -->
    <div class="basic">
      <van-cell-group title="基础信息">
        <van-cell v-if="resData.carSizeTypeName" title="车辆类型" :value="resData.carSizeTypeName" />
        <van-cell v-if="resData.carBrandName" title="品牌" :value="resData.carBrandName" />
        <van-cell v-if="table.carColorName" title="车辆颜色" :value="table.carColorName" />
        <van-cell v-if="table.interiorColorName" title="内饰颜色" :value="table.interiorColorName" />
        <van-cell v-if="resData.carSeriesName" title="车系" :value="resData.carSeriesName" />
        <van-cell v-if="resData.carModelName" title="车型" :value="resData.carModelName" />
        <van-cell v-if="resData.locationProvinceName && resData.locationCityName" title="车辆所在地" :value="resData.locationProvinceName + resData.locationCityName" />
        <van-cell v-if="resData.ownerProvinceName && resData.ownerCityName" title="车辆归属地" :value="resData.ownerProvinceName + resData.ownerCityName" />
        <van-cell v-if="table.carUsageModeName" title="使用性质" :value="table.carUsageModeName" />
        <van-cell v-if="resData.mileageStart && resData.mileageEnd" title="里程数" :value="resData.mileageStart + '-' +resData.mileageEnd + '万公里'" />
        <van-cell v-if="resData.firstLicenseStartDate && resData.firstLicenseEndDate" title="初次上牌" :value="resData.firstLicenseStartDate + ' - ' +resData.firstLicenseEndDate" />
        <van-cell v-if="resData.manufactureStartDate && resData.manufactureEndDate" title="出厂日期" :value="resData.manufactureStartDate + ' - ' +resData.manufactureEndDate" />
      </van-cell-group>
      <van-cell-group title="参数配置">
        <van-cell v-if="resData.airIntakeMethodName" title="进气方式" :value="resData.airIntakeMethodName" />
        <van-cell v-if="resData.emissionsStandardsName" title="排放标准" :value="resData.emissionsStandardsName" />
        <van-cell v-if="resData.carDriverTypeName" title="驱动形式" :value="resData.carDriverTypeName" />
        <van-cell v-if="resData.carOilSystemName" title="供油系统" :value="resData.carOilSystemName" />
        <van-cell v-if="resData.carGearboxTypeName" title="变速箱" :value="resData.carGearboxTypeName" />
        <van-cell v-if="resData.carBodyTypeName" title="车体形式" :value="resData.carBodyTypeName" />
        <van-cell v-if="resData.outputVolume" title="车辆排量" :value="resData.outputVolume" />
        <van-cell v-if="resData.enduranceMileage" title="续航里程" :value="resData.enduranceMileage + 'km'" />
        <van-cell v-if="resData.cargoCapacity" title="载货容积" :value="resData.cargoCapacity + 'm³'" />
        <van-cell v-if="resData.deadweight" title="载重" :value="resData.deadweight + 'kg'" />
      </van-cell-group>
      <van-cell-group title="手续信息">
        <van-cell v-if="resData.compulsoryInsuranceStartDate && resData.compulsoryInsuranceEndDate" title="交强险到期" :value="resData.compulsoryInsuranceStartDate + '-' + resData.compulsoryInsuranceEndDate" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Header, Toast } from "mint-ui";
import {
  API_GET,
  API_POST,
  API_POST_JSON,
  API_GET_JSON,
  getLocation,
  GET_DICT
} from "@/apiConfig";
export default {
  name: "Configure",
  data() {
    return {
      resData: {
        carBrandName:"",
        carSeriesName:"",
        carModelName:"",
        locationCityName:"",
        ownerCityName:"",
        mileageBegin:"",
        mileageEnd:"",
        firstLicenseDateBegin:"",
        firstLicenseDateEnd:"",
        manufactureDateBegin:"",
        manufactureDateEnd:"",
        outputVolumne:"",
        compulsoryInsuranceDueDateBegin:"",
        compulsoryInsuranceDueDateEnd:"",
        type:"",
      },
      GET_DICT: function() {},
      loading: false,
      table:{
        carColor:"", //车辆颜色
        interiorColor: "", //内饰颜色
        useCharacter: "", //使用性质
        airIntakeMethod:"",//排气方式
        carOilSystem:"",//供油系统
        carEmissionsStandard:"",//排放标准
        carDriverType:"",//驱动形式
        carGearboxType:"",//变速箱
        purchaseTaxList:"",//购置税
        outputVolumne:"",//排量
        carBodyType:"",//车体形式
      }
    };
  },
  mounted() {
    this.fetchData();
    // this.getDict()
    window.scroll(0, 0);
    this.GET_DICT = GET_DICT;
  },
  methods: {
    goback: function() {
      window.history.go(-1);
    },

    fetchData: function() {
      let body = {
        id: this.$route.params.id
      };
      if (body.id != null) {
        this.loading = true;
        API_GET("/lianlianche-car/carRentalInfo/share/getById", body).then(res => {
          this.loading = false;
          if (res.status == 0) {
            this.resData = res.data;
          } else {
            Toast({
              message: res.msg
            });
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/carConfigure.vue